import { Insurance } from '@core/constants/data-types.constants';

export interface MenuProtection {
  active: boolean;
  insurance: Insurance;
  path: string;
  shortName: string;
  longName: string;
  icon: string;
  productsAdded: number;
  totalProducts: number;
  healthPoints: number;
}

export const DeathMenuProtection: MenuProtection = {
  active: false,
  insurance: 'DEATH',
  path: 'death',
  shortName: 'MENU.LIFE_PLAN.DEATH.SHORT_NAME',
  longName: 'MENU.LIFE_PLAN.DEATH.LONG_NAME',
  icon: 'assets/icons/death-menu.svg',
  productsAdded: 0,
  totalProducts: 0,
  healthPoints: 0
};

export const EducationMenuProtection: MenuProtection = {
  active: false,
  insurance: 'EDUCATION',
  path: 'education',
  shortName: 'MENU.LIFE_PLAN.EDUCATION.SHORT_NAME',
  longName: 'MENU.LIFE_PLAN.EDUCATION.LONG_NAME',
  icon: 'assets/icons/education-menu.svg',
  productsAdded: 0,
  totalProducts: 0,
  healthPoints: 0
};

export const SavingMenuProtection: MenuProtection = {
  active: false,
  insurance: 'SAVING',
  path: 'savings',
  shortName: 'MENU.LIFE_PLAN.SAVINGS.SHORT_NAME',
  longName: 'MENU.LIFE_PLAN.SAVINGS.LONG_NAME',
  icon: 'assets/icons/saving-menu.svg',
  productsAdded: 0,
  totalProducts: 0,
  healthPoints: 0
};

export const RetirementMenuProtection: MenuProtection = {
  active: false,
  insurance: 'RETIREMENT',
  path: 'retirement',
  shortName: 'MENU.LIFE_PLAN.RETIREMENT.SHORT_NAME',
  longName: 'MENU.LIFE_PLAN.RETIREMENT.LONG_NAME',
  icon: 'assets/icons/retirement-menu.svg',
  productsAdded: 0,
  totalProducts: 0,
  healthPoints: 0
};

export const DecumulationMenuProtection: MenuProtection = {
  active: true,
  insurance: 'DECUMULATION',
  path: 'decumulation',
  shortName: 'MENU.LIFE_PLAN.DECUMULATION.SHORT_NAME',
  longName: 'MENU.LIFE_PLAN.DECUMULATION.LONG_NAME',
  icon: 'assets/icons/decumulation-menu.svg',
  productsAdded: 0,
  totalProducts: 0,
  healthPoints: 0
};